export default __webpack_public_path__ + "static/media/Placeholder-WstoreCategory.87d6d5c2.png";